<div class="file-field-wrapper">
    <strong class="label">{{ element.label | htmlDecode }}</strong>
    <a [href]="'/form/submitFileUpload/' + element.fileId + '/' + element.value" target="_blank">
        {{ element.value }}
    </a>
</div>